import { COLLECTIONS } from '@/mocks/kanliao';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
          {/* brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-line text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">看料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              看料是一个中文网址导航与地址汇总，把影视、综艺动漫、直播、资讯、资源、工具等热门站点整理成清晰分类，一键直达不迷路。持续收录新地址，失效入口随时补充。
            </p>
          </div>

          {/* category quick links */}
          <div>
            <h4 className="text-sm font-bold text-foreground-900">分类合集</h4>
            <ul className="mt-3 space-y-2">
              {COLLECTIONS.map((c) => (
                <li key={c.id}>
                  <a
                    href={`#col-${c.id}`}
                    className="inline-flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <span className="serif-num text-xs font-bold text-primary-600">{c.index}</span>
                    {c.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* usage */}
          <div>
            <h4 className="text-sm font-bold text-foreground-900">站内直达</h4>
            <ul className="mt-3 space-y-2">
              <li><a href="#featured" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">本日精选</a></li>
              <li><a href="#topics" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">话题热榜</a></li>
              <li><a href="#updates" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">最新收录</a></li>
              <li><a href="#tips" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">收藏指引</a></li>
            </ul>
            <h4 className="mt-6 text-sm font-bold text-foreground-900">温馨提示</h4>
            <p className="mt-2 text-xs leading-5 text-foreground-500">
              本站仅作网址导航收录，内容版权归原站点所有；请合理使用、遵守相关法律法规。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-4 py-5 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p className="text-xs text-foreground-500">© {year} 看料 · 网址导航 · 地址汇总。打开就能找到想看的内容。</p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-record-circle-line text-accent-600" />
            持续收录中 · 一键直达
          </p>
        </div>
      </div>
    </footer>
  );
}